import React, { Component } from 'react';
import './App.css';
import HwStatus from './HwStatus'
import DeviceCollection from "./Scenarios/DeviceCollection";
import LoadingSpinner from './Utils/LoadingSpinner';


class AppWithAuth extends Component {

    state = {
        loading: true, // will be true when ajax request is running
    };

    // This method is called by React once DOM is ready
    componentDidMount() {
        this.refreshUserDevices();
    }

    render() {

        let hw_status = <HwStatus
            id_token={this.props.id_token}
            urls={this.props.urls}
            onDeviceStarted={this.refreshUserDevices}
            onDeviceStopped={this.refreshUserDevices}
        />;

        let deviceCollection;

        if( this.state.loading) {
            deviceCollection = <LoadingSpinner text="Loading list of user devices ..." />
        }else{
            deviceCollection = <DeviceCollection {...this.props}
                                                 devices={this.state.devices}
                                                 onChange={this.refreshUserDevices}
            />;
        }

        return (
            <div className="App">
                {hw_status}
                {deviceCollection}
            </div>
            );
    }

    refreshUserDevices = () => {

        this.setState({loading:true}, () => {

            this.props.simGps.getUserDevices( (success, result) => {
                if( success ){
                    this.setState({
                        loading: false,
                        devices: result.devices,
                    });
                    console.log('Devices ' + JSON.stringify(result.devices));
                }else{
                    this.setState({
                        error: result,
                        loading: false
                    });
                }
            });


        });
    }
}

export default AppWithAuth;
